// export default RDDDManualPay;
import React, { useEffect, useState } from "react";
import "./RDDDPreClosure.css";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const API_URL = "https://payyug.in/api";

const RDDDManualPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.userProfile);

  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [payLoading, setPayLoading] = useState(false);

  const [formData, setFormData] = useState({
    amount: "",
    paymentMode: "CASH",
    transactionDate: new Date().toISOString().split("T")[0],
    narration: "",
  });

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // Fetch accounts list
  const fetchAccountsList = async () => {
    try {
      const superAdminId = profile?.superAdminId || 14;
      const branchId = localStorage.getItem("userId") || 56;
      const res = await axios.get(`${API_URL}/deposit/list`, {
        params: { superAdminId, branchId },
      });
      if (res.data.success) {
        const allAccounts = res.data.data || [];
        // const pigmyAccounts = allAccounts.filter(
        //   (pa) => pa?.accountType === "DD" || pa?.accountType?.toLowerCase() === "pigmy"
        // );
        setAccounts(allAccounts);
      }
    } catch (err) {
      console.error("Error fetching accounts:", err);
    }
  };

  useEffect(() => {
    if (profile) fetchAccountsList();
  }, [profile]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePreview = (e) => {
    e.preventDefault();
    if (!selectedAccount) return toast.warn("Please select an account");
    if (!formData.amount || Number(formData.amount) <= 0)
      return toast.warn("Please enter a valid amount");
    setShowPreview(true);
  };

  const handleSubmit = async () => {
    try {
      setPayLoading(true);
      const payload = {
        superAdminId: Number(profile?.superAdminId || 14),
        branchId: Number(profile?.branchId || 56),
        accountId: Number(selectedAccount.id),
        amount: Number(formData.amount),
        collectionDate: formData.transactionDate,
        collectionMode: formData.paymentMode,
        collectedBy: Number(profile?.id || localStorage.getItem("userId") || 1),
        remarks: formData.narration,
        type: selectedAccount?.accountType,
        status: "Paid",
      };

      const res = await axios.post(
        `${API_URL}/deposit/pay-dd-alternative`,
        payload,
      );

      if (res.data.success) {
        toast.success(res?.data?.message || "Alternate Payment Successfully!");
        setShowPreview(false);
        navigate("/Banking/DepositAccount/AlternatePaymentReceipt", {
          state: { currentAccountData: selectedAccount, payment:res?.data },
        });
      } else {
        toast.error(res.data.message || "Payment failed");
      }
    } catch (err) {
      toast.error("An error occurred during payment");
    } finally {
      setPayLoading(false);
    }
  };

  return (
    <div className="saving-account-transaction-container">
      <h2>RD/DD Manual Payment Portal</h2>

      <form
        className="saving-account-transaction-payment-details"
        onSubmit={handlePreview}
      >
        <h4>
          <i className="fa-solid fa-calendar-check"></i> EMI Schedule Summary
        </h4>

        {selectedAccount && (
          <div className="scheme-details-banner">
            <h4>
              <i className="fa-solid fa-circle-info"></i> Scheme Info:{" "}
              {selectedAccount.schemeName}
            </h4>
            <div className="scheme-info-grid">
              <div className="info-item">
                <span>ROI:</span>
                <strong>{selectedAccount.roi}%</strong>
              </div>
              <div className="info-item">
                <span>Freq:</span>
                <strong>{selectedAccount.installmentFrequency}</strong>
              </div>
              <div className="info-item">
                <span>Lock-in:</span>
                <strong>
                  {selectedAccount.scheme?.depositLockinPeriod || 0} Months
                </strong>
              </div>
              <div className="info-item">
                <span>Pre-Close ROI:</span>
                <strong>{selectedAccount.scheme?.preClosureRoi || 0}%</strong>
              </div>
              <div className="info-item">
                <span>Late Fine:</span>
                <strong>
                  ₹ {selectedAccount.scheme?.installmentPenaltyValue || 0}
                </strong>
              </div>
              <div className="info-item">
                <span>Status:</span>
                <strong
                  className={`status-${selectedAccount.status?.toLowerCase()}`}
                >
                  {selectedAccount.status}
                </strong>
              </div>
            </div>
          </div>
        )}

        <div className="payment-details-container">
          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Select Account</label>
              <Select
                placeholder="Search Account..."
                options={accounts.map((acc) => ({
                  value: acc.id,
                  label: `${acc.customerName} | ${acc.accountNo}`,
                  account: acc,
                }))}
                onChange={(selected) =>
                  setSelectedAccount(selected?.account || null)
                }
                isSearchable
                isClearable
              />
            </div>
            <div className="payment-details-inputs">
              <label>Total Deposits</label>
              <input
                type="number"
                readOnly
                value={selectedAccount?.totalDeposited}
              />
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Amount (INR)</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                required
              />
            </div>
            <div className="payment-details-inputs">
              <label>Collection Date</label>
              <input
                type="date"
                name="transactionDate"
                value={formData.transactionDate}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="payment-details-input-groups">
            <div className="payment-details-inputs">
              <label>Payment Mode</label>
              <select
                name="paymentMode"
                value={formData.paymentMode}
                onChange={handleChange}
              >
                <option value="CASH">CASH</option>
                <option value="UPI">UPI</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
              </select>
            </div>
            <div className="payment-details-inputs">
              <label>Remarks</label>
              <input
                type="text"
                name="narration"
                value={formData.narration}
                onChange={handleChange}
                placeholder="Optional narration"
              />
            </div>
          </div>
        </div>

        {/* <div className="kyc-section-title">Customer KYC Documents</div>
        <div className="kyc-cards-container">
          {loading ? (
            <p>Loading KYC data...</p>
          ) : uploadedKyc.length === 0 ? (
            <p className="no-kyc">No KYC documents found</p>
          ) : (
            uploadedKyc.map((doc, index) => (
              <div className="kyc-card" key={index}>
                <img src={`https://payyug.in/uploads/${doc.docImage}`} alt="KYC" className="kyc-image" />
                <p className="doctitle">{doc.docName || "Document"}</p>
              </div>
            ))
          )}
        </div> */}

        <div className="pay-btn">
          {/* Replaced broken currentPendingEmi validation logic with standard form state validity checking */}
          <button type="submit" disabled={!selectedAccount || loading}>
            {loading ? "Loading..." : "Verify & Pay EMI"}
          </button>
        </div>
      </form>

      {showPreview && (
        <div className="modal-overlay">
          <div className="transaction-modal">
            <h3>Confirm EMI Collection</h3>
            <div className="modal-content">
              <div className="modal-row">
                <span>Customer:</span>{" "}
                <strong>{selectedAccount?.customerName}</strong>
              </div>
              <div className="modal-row">
                <span>Mode:</span> <strong>{formData.paymentMode}</strong>
              </div>
              <div className="modal-row amount-row">
                <span>Amount:</span> <strong>₹ {formData.amount}</strong>
              </div>
            </div>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowPreview(false)}
                disabled={payLoading}
              >
                Edit
              </button>
              <button
                className="confirm-btn"
                onClick={handleSubmit}
                disabled={payLoading}
              >
                {payLoading ? "Processing..." : "Pay Now"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RDDDManualPay;
